export default __webpack_public_path__ + "static/screen-placement-b893f05c05609ea2a8f68e5f296f1a66.png";